import React, { useMemo } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { ReactComponent as CalendarDayIcon } from 'assets/CalendarDay.svg'
import ServiceDetailChip from 'components/configured-service/layout/ServiceDetailChip'
import { useCSDetailsCachedData } from 'components/configured-service/useCSDetailsCachedData'
import { selectDeactivateOnEndDate, selectEndDate } from 'data/configured-service/configuredServiceDetailsSelectors'
import { selectIsInventoryPlacementsEnabled } from 'data/tenant/tenantSettingsSelectors'
import T from 'T'

// Untyped .jsx child — cast at the module boundary; remove when it migrates.
const ServiceDetailChipUntyped = ServiceDetailChip as React.ElementType

interface ServiceEndDateChipProps {
  id?: string
}

const ServiceEndDateChip = ({ id, ...props }: ServiceEndDateChipProps) => {
  const { data = {} } = useCSDetailsCachedData({ id })
  const isInventoryPlacementsEnabled = useSelector(selectIsInventoryPlacementsEnabled, shallowEqual)
  const endDate = useMemo(() => selectEndDate(data), [data])
  // An end date alone is a date the service runs to; with this it is also the day it switches off.
  const willDeactivate = useMemo(
    () => isInventoryPlacementsEnabled && Boolean(selectDeactivateOnEndDate(data)),
    [isInventoryPlacementsEnabled, data]
  )

  return (
    <ServiceDetailChipUntyped
      IconComponent={CalendarDayIcon}
      label={endDate}
      paletteColor={willDeactivate ? 'warning' : 'error'}
      tooltip={willDeactivate ? `${T.SCHEDULED_TO_DEACTIVATE_ON} ${endDate}` : T.END_DATE}
      {...props}
    />
  )
}

export default ServiceEndDateChip
